import { formatCurrency } from '@/utils';

let items = [];

export default {
  beforeList: ({ form, schema, route }) => {
    if (items.length === 0) {
      items = schema.listActions.more.items;
    }

    if (route.name === 'order-budgets') {
      schema.listActions.more.items = items.filter(item => item.name === 'generateOrder' || item.name === 'print' || item.name === 'duplicateOrder');
    } else {
      schema.listActions.more.items = items.filter(item => item.name !== 'generateOrder');
      form.orders.forEach((order) => {
        const statusDisabled = ['finished', 'canceled', 'returned', 'reversed'];
        order.destroyDisabled = statusDisabled.includes(order.status);
        order.disableItemMoreActions = {
          generateInvoice:
            (order.product_invoice_id &&
              order.product_invoice?.status === 'authorized') ||
            !order.is_delivered,
          showInvoice: !order.product_invoice_id ? true : false,
          duplicateOrder: false,
          devolutionOrder: !['finished'].includes(order.status),
          reverseOrder: !['finished'].includes(order.status),
          print: false,
          download: false,
        };
      });
      form.value_total_pending = formatCurrency(form.value_total_pending);
      form.value_total_delivered = formatCurrency(form.value_total_delivered);
    }
  },
};
